import { Component, Renderer2 } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, NavigationEnd } from "@angular/router";
import { ApplicationUtilsService } from "@util-services";
import {isEmptyValue} from "@helpers";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  standalone: false,
})
export class AppComponent {
  header: string;
  footer: string;


  constructor(
    private router: Router,
    private title: Title,
    private appService: ApplicationUtilsService,
    private renderer: Renderer2
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.header = this.getHeader(event.url);
        this.footer = this.getFooter(event.url);
        if (!isEmptyValue(this.header)) {
          this.title.setTitle(this.header + " | NVWA");
        } else {
          this.title.setTitle("NVWA");
        }
      }
    });
    // Class hidden toevoegen zodat in de index.html de loading-spinner uitgezet kan worden.
    const element = document.querySelector(".loading");
    if (!isEmptyValue(element)) {
      this.renderer.addClass(element, "hidden");
    }
  }

  getHeader(url): string {
    return this.getPrompt("DOWNLOAD_EPHYTO.HEADER");
  }

  getFooter(url): string {
    switch (url) {
      case "/download-ephyto":
        return this.getPrompt("DOWNLOAD_EPHYTO.HEADER");
    }
  }

  getPrompt(prompt): string {
    return this.appService.getPrompt(prompt);
  }
}
